const API_BASE_URL = '/api';


const downloadCSV = async (endpoint, startDate, endDate, countryCode, filename) => {
  try {
    const body = { start_date: startDate, end_date: endDate };
    if (countryCode) body.country_code = countryCode;

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'text/csv'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error(`Failed to download ${filename}:`, e);
  }
};

export const getFeedbackLogs = (startDate, endDate, countryCode) =>
  downloadCSV('/admin/getfeedbacklogs', startDate, endDate, countryCode, 'feedback_logs.csv');

export const getChatLogs = (startDate, endDate, countryCode) =>
  downloadCSV('/admin/getchatlogs', startDate, endDate, countryCode, 'chat_logs.csv');